// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../img/background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VirtualCard_main__Up5r4 {
  background-color: var(--color-primary-3);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  transition: all 0.4s;
  width: 38rem;
  border-radius: 1rem;
  padding: 2rem;
  box-sizing: border-box;
  margin-bottom: 2rem;
}
.VirtualCard_main__icon__d5Ea1 {
  height: 3rem;
}
.VirtualCard_main__cardDetails__i4Kv5 {
  display: flex;
  gap: 3rem;
  color: var(--color-dark-web);
}

.VirtualCard_cardInfo__sKUjG {
  width: 38.4rem;
  padding: 1rem 0;
  margin-top: 2rem;
  box-sizing: border-box;
  border-radius: 1rem;
  line-height: 1rem;
  font-size: 0.8rem;
  border: 1px solid #B3B3C5;
  align-items: baseline;
  margin-bottom: 2rem;
}
.VirtualCard_cardInfo__items__5RGDz {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #B3B3C5;
  padding: 1.5rem;
}
.VirtualCard_cardInfo__items_item__FFyLM {
  display: flex;
  font-size: 1.4rem;
  line-height: 1.2rem;
  margin-top: 0.5rem;
}

.VirtualCard_imgBg__4RA7w {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10rem;
  height: 10rem;
  border-radius: 50%;
  margin-top: 6rem;
  margin-bottom: 2rem;
  background-color: var(--color-primary-3);
}
.VirtualCard_imgBg__img__HtQ6x {
  width: 7rem;
  height: 7rem;
}

.VirtualCard_cardBottom__1ehFZ {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.VirtualCard_cardNo__lz8uO {
  width: 100%;
  display: flex;
  justify-content: center;
  font-family: "Courier New", Courier, monospace;
  font-weight: 700;
  font-size: 2.4rem;
  margin: 1rem 0 2rem 0;
}

.VirtualCard_cardBeside__P-6bi {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;
}
.VirtualCard_cardBeside__P-6bi > :not(:last-child) {
  margin-right: 1rem;
}

.VirtualCard_fullCard__Pswx6 {
  width: 38rem;
}
.VirtualCard_fullCard__Pswx6 > :not(:last-child) {
  margin-right: 1rem;
}
.VirtualCard_fullCard_info__\\+ECwI {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--color-primary);
  width: 38rem;
}
.VirtualCard_fullCard_icon__8G\\+9V {
  font-size: 3rem;
}
.VirtualCard_fullCard_icon__8G\\+9V:hover, .VirtualCard_fullCard_icon__8G\\+9V:focus, .VirtualCard_fullCard_icon__8G\\+9V:active {
  color: var(--color-primary);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Wallet/VirtualCard.module.scss"],"names":[],"mappings":"AAEA;EACC,wCAAA;EACA,yDAAA;EACA,sBAAA;EACA,oBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AADD;AAGC;EACE,YAAA;AADH;AAIC;EACC,aAAA;EACA,SAAA;EACA,4BAAA;AAFF;;AAMA;EACC,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;AAHD;AAOC;EACC,aAAA;EACA,8BAAA;EACA,gCAAA;EACA,eAAA;AALF;AAOE;EACC,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AALH;;AAUA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wCAAA;AAPD;AASC;EACC,WAAA;EACA,YAAA;AAPF;;AAWA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AARD;;AAWA;EACC,WAAA;EACA,aAAA;EACA,uBAAA;EACA,8CAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AARD;;AAWA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AARD;AAUC;EACC,kBAAA;AARF;;AAYA;EACC,YAAA;AATD;AAUC;EACC,kBAAA;AARF;AAWC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,6CAAA;EACA,YAAA;AATF;AAYC;EACC,eAAA;AAVF;AAYE;EAGC,2BAAA;AAZH","sourcesContent":["@import '../variables/breakpoints';\n\n.main {\n\tbackground-color: var(--color-primary-3);\n\tbackground-image: url('../../img/background.png');\n\tbackground-size: cover;\n\ttransition: all 0.4s;\n\twidth: 38rem;\n\tborder-radius: 1rem;\n\tpadding: 2rem;\n\tbox-sizing: border-box;\n\tmargin-bottom: 2rem;\n\n\t&__icon {\n\t\t height: 3rem;\t\t\n\t}\n\n\t&__cardDetails {\n\t\tdisplay: flex;\n\t\tgap: 3rem;\n\t\tcolor: var(--color-dark-web);\n\t}\n}\n\n.cardInfo {\n\twidth: 38.4rem;\n\tpadding: 1rem 0;\n\tmargin-top: 2rem;\n\tbox-sizing: border-box;\n\tborder-radius: 1rem;\n\tline-height: 1rem;\n\tfont-size: 0.8rem;\n\tborder: 1px solid #B3B3C5;\t\n\talign-items: baseline;\n\tmargin-bottom: 2rem;\n\n\n\n\t&__items {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tborder-bottom: 1px solid #B3B3C5;\n\t\tpadding: 1.5rem;\n\n\t\t&_item {\n\t\t\tdisplay: flex;\t\t\t\n\t\t\tfont-size: 1.4rem;\n\t\t\tline-height: 1.2rem;\n\t\t\tmargin-top: 0.5rem;\n\t\t}\n\t}\n}\n\n.imgBg {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\twidth: 10rem;\n\theight: 10rem;\n\tborder-radius: 50%;\n\tmargin-top: 6rem;\n\tmargin-bottom: 2rem;\n\tbackground-color: var(--color-primary-3);\n\n\t&__img {\n\t\twidth: 7rem;\n\t\theight: 7rem;\n\t}\n}\n\n.cardBottom {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n}\n\n.cardNo {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\tfont-family: 'Courier New', Courier, monospace;\n\tfont-weight: 700;\n\tfont-size: 2.4rem;\n\tmargin: 1rem 0 2rem 0;\n}\n\n.cardBeside {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tmargin-bottom: 2rem;\n\n\t& >:not(:last-child) {\n\t\tmargin-right: 1rem;\n\t}\n}\n\n.fullCard {\n\twidth: 38rem;\n\t& >:not(:last-child) {\n\t\tmargin-right: 1rem;\n\t}\n\n\t&_info {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tmargin-bottom: 1rem;\n\t\tpadding-bottom: 1rem;\n\t\tborder-bottom: 1px solid var(--color-primary);\n\t\twidth: 38rem;\n\t}\n\n\t&_icon {\n\t\tfont-size: 3rem;\n\n\t\t&:hover,\n\t\t&:focus,\n\t\t&:active {\n\t\t\tcolor: var(--color-primary);\n\t\t}\n\n\t}\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `VirtualCard_main__Up5r4`,
	"main__icon": `VirtualCard_main__icon__d5Ea1`,
	"main__cardDetails": `VirtualCard_main__cardDetails__i4Kv5`,
	"cardInfo": `VirtualCard_cardInfo__sKUjG`,
	"cardInfo__items": `VirtualCard_cardInfo__items__5RGDz`,
	"cardInfo__items_item": `VirtualCard_cardInfo__items_item__FFyLM`,
	"imgBg": `VirtualCard_imgBg__4RA7w`,
	"imgBg__img": `VirtualCard_imgBg__img__HtQ6x`,
	"cardBottom": `VirtualCard_cardBottom__1ehFZ`,
	"cardNo": `VirtualCard_cardNo__lz8uO`,
	"cardBeside": `VirtualCard_cardBeside__P-6bi`,
	"fullCard": `VirtualCard_fullCard__Pswx6`,
	"fullCard_info": `VirtualCard_fullCard_info__+ECwI`,
	"fullCard_icon": `VirtualCard_fullCard_icon__8G+9V`
};
export default ___CSS_LOADER_EXPORT___;
